import {NgModule} from '@angular/core';
import {OrderByPipe} from './sortBy.pipe';
import {ShowCharactersPipe} from './showCharacters.pipe';
import {CapitalizeFirstLetterPipe} from './capitalize-first-letter.pipe';
import {MusicStylePipe} from './music-styles.pipe';
import {TruncatePipe} from './text-truncate.pipe';

@NgModule({
  declarations: [OrderByPipe, ShowCharactersPipe, CapitalizeFirstLetterPipe, MusicStylePipe, TruncatePipe],
  exports: [OrderByPipe, ShowCharactersPipe, CapitalizeFirstLetterPipe, MusicStylePipe, TruncatePipe],
})
export class PipesModule {}
